import React from 'react';
import './MiniCard.css';

export const MiniCard = (props) => {
    return(
        <div className='mini-card'>
            <span className='mini-card__name'>{props.name}</span>
            <img src={props.image} alt={props.alt} />
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/components/content-container/mini-card/MiniCard.jsx